<script setup>
import { Toggle, Tabs, Tab, Card, Label, Input, Dropdown, Hint, ColorPicker, Textarea, Select, Button, Icon, Modal, Checkbox, TextEditor } from '@components'
import { ref, reactive, onMounted, computed } from 'vue'

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

// Route.
import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const router = useRouter()

// Store
import { useNotification } from '@store/notification'
const $notification = useNotification()

import { useSettings } from '@store/settings'
const $settings = useSettings()


const notificationId = computed(() => {
    return route.params.notificationId
})

const email = ref(prebook_admin.settings.notification.emails[notificationId.value])

// const $settings = window.prebook_admin.settings || {}

// active editor state
// const activeEditor = ref('Text')
// const editorOptions = ref([
//     { type: 'Text', icon: 'alignLeft' },
//     { type: 'Code', icon: 'code02' }
// ])


// preview device state
const activePreviewDevice = ref('desktop')
const previewDevices = ref([
    { name: 'desktop', icon: 'monitor02' },
    { name: 'mobile', icon: 'phone02' },
    { name: 'tablet', icon: 'tablet01' },
])
const previewWidth = computed(() => {
    if (activePreviewDevice.value == 'desktop') return '100%'
    else if (activePreviewDevice.value == 'mobile') return '320px'
    else if (activePreviewDevice.value == 'tablet') return '475px'
})


const changePreviewDevice = (device) => {
    if (activePreviewDevice.value == device) activePreviewDevice.value = ''
    else activePreviewDevice.value = device
}

// const socialMedia = ref([
//     { name: 'Facebook', icon: 'facebook', url: 'https://www.facebook.com/' },
//     { name: 'Twitter', icon: 'twitter', url: 'https://twitter.com/' },
//     { name: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/' },
// ])


const activeTab = computed(() => {
    return route.query.tab || 'customer'
})

const email_footer = computed(() => {
    const year = new Date().getFullYear()
    return `This email was sent to ` + (activeTab.value == 'customer' ? 'customer' : 'staff') + `@` + (prebook_admin?.site?.host || 'prebook') + `. If you'd rather not receive this kind of email, you can unsubscribe or manage your email preferences. © 
    ` + year + ` ` + prebook_admin.settings.business?.name
})

const update = async () => {
    $notification.notifications.emails[notificationId.value] = email.value
    await $notification.updateNotification()
    // router.push({ name: 'notification.list' })
}

const placeholders = computed(() => {
    const items = prebook_admin.options.email_placeholders || {}

    return Object.keys(items).map(key => {
        return {
            value: key,
            label: '<div class="flex items-center justify-between gap-2">' + items[key] + ' <span class="text-sm text-gray-500">{' + key + '}<span></div>'
        }
    })
})

const insertPlaceholder = (placeholder) => {
    if (activeTab.value === 'customer') {
        email.value.customer_body += ` {${placeholder}}`
    } else {
        email.value.staff_body += ` {${placeholder}}`
    }

    Log(placeholder)
}
const editorToolbar = ref([{ 'size': ['small', false, 'large', 'huge'] }, { 'header': [1, 2, 3, 4, 5, 6, false] }, 'bold', 'italic', 'underline', 'strike', 'code-block', 'link', 'clean'])
</script>
<template>
    <div class="my-[-60px] w-full flex m-auto justify-center md:min-h-[85vh]">
        <!-- editor form -->
        <div class="lg:w-[720px] pt-[50px] mx-[20px] pb-[10px]">
            <Tabs default="customer" tabWrapperClass="w-full md:w-[367px]">
                <Tab id="customer" class="capitalize">{{ $settings.labels.customer?.singular }}</Tab>
                <Tab id="employee" class="capitalize">
                    {{ $settings.addons.staffs ? $settings.labels.staff?.singular || 'Staff' : 'Service Provider' }}
                </Tab>

                <template #customer>
                    <div class="mt-7">
                        <h1 class="text-[#101828] text-xl font-semibold p-[8px_32px_8px_0px] mb-7 capitalize">{{ String(email.title).replace('Appointment', $settings.labels.appointment?.singular) }}</h1>
                        <div class="w-full mb-7">
                            <Label>Subject</Label>
                            <Input v-model="email.customer_subject" class="mt-1.5" inputContainerClass="px-4"></Input>
                        </div>
                        <div class="flex flex-col w-full gap-2 mb-7">
                            <Label>Message Placeholders</Label>
                            <!-- <Dropdown contentClass="w-full top-[66px] max-h-lg overflow-auto">
                                <Input v-model="email.placeholder" class="mt-1.5 w-full" iconLeft="searchLg" placeholder="Click to copy or search email placeholders" inputContainerClass="p-4"></Input>

                                <template #content>
                                    <div v-for="item in placeholders" @click="insertPlaceholder( item.key )" class="cursor-pointer mx-1 px-3 py-[10px] text-[#101828] hover:bg-[#F0F1F4] rounded mb-1 last:mb-0" :class="{ 'bg-[#F0F1F4]': email.placeholder == item.key }" v-html="item.label"></div>
                                </template>
</Dropdown> -->
                            <Select :search="true" placeholder="Search placeholder" :selector="false" v-model="email.placeholder" @change="insertPlaceholder" :options="placeholders"></Select>

                        </div>
                        <div class="w-full mb-7">
                            <Label>Message</Label>
                            <div class="mt-1.5">
                                <QuillEditor theme="snow" :toolbar="editorToolbar" v-model:content="email.customer_body" contentType="html" />
                            </div>
                        </div>
                        <!-- actions -->
                        <div class="flex items-center justify-between gap-10">
                            <Button size="xl" type="secondary_gray" radius="square" classButton="!w-[95px]" @click.prevent="$router.push({ name: 'notification.list' })"> Back </Button>
                            <Button :submit="true" size="xl" type="primary" radius="square" classButton="w-[219px]" @click="update"> Update </Button>
                        </div>
                    </div>
                </template>
                <template #employee>
                    <div class="mt-7">
                        <h1 class="text-[#101828] text-xl font-semibold p-[8px_32px_8px_0px] mb-7">{{ String(email.title).replace('Appointment', $settings.labels.appointment?.singular) }}
                        </h1>
                        <div class="w-full mb-7">
                            <Label>Subject</Label>
                            <Input v-model="email.staff_subject" class="mt-1.5" inputContainerClass="px-4"></Input>
                        </div>
                        <div class="flex flex-col w-full gap-2 mb-7">
                            <Label>Message Placeholders</Label>
                            <!-- <Dropdown contentClass="w-full top-[66px]">
                                <Input v-model="email.placeholder" class="mt-1.5 w-full" iconLeft="searchLg" placeholder="Click to copy or search email place holders" inputContainerClass="p-4"></Input>

                                <template #content>
                                    <div v-for="item in ['Name', 'Email', 'Phone', 'Address']" @click="email.placeholder = item" class="cursor-pointer mx-1 px-3 py-[10px] text-[#101828] hover:bg-[#F0F1F4] rounded mb-1 last:mb-0" :class="{ 'bg-[#F0F1F4]': email.placeholder == item }">{{ item }}</div>
                                </template>
</Dropdown> -->
                            <Select :search="true" placeholder="Search placeholder" :selector="false" v-model="email.placeholder" @change="insertPlaceholder" :options="placeholders"></Select>
                        </div>
                        <div class="w-full mb-7">
                            <Label>Message</Label>
                            <div class="mt-1.5">
                                <QuillEditor theme="snow" :toolbar="editorToolbar" v-model:content="email.staff_body" contentType="html" />
                            </div>

                        </div>
                        <!-- actions -->
                        <div class="flex items-center justify-between gap-10">
                            <Button size="xl" type="secondary_gray" radius="square" classButton="!w-[95px]" @click.prevent="$router.push({ name: 'notification.list' })"> Back </Button>
                            <Button :submit="true" size="xl" type="primary" radius="square" classButton="w-[219px]" @click="update"> Update </Button>
                        </div>
                    </div>
                </template>
            </Tabs>
        </div>
        <!--preview-->
        <div class="border-l border-l-[#F2F4F7] pt-[50px] px-[20px] pb-[10px]">
            <div class="md:w-[600px] m-auto">
                <!-- header -->
                <div class="flex items-center justify-between">
                    <p class="text-[#101828] font-semibold text-xl">Preview</p>
                    <div class="flex gap-2">
                        <Icon v-for="device in previewDevices" :name="device.icon" size="40px" class="p-2 rounded-md cursor-pointer hover:bg-white hover:text-[#101828] transition-all duration-300 hover:shadow-[0px_1px_2px_0px_#1018280D]" :class="[activePreviewDevice == device.name ? 'shadow-[0px_1px_2px_0px_#1018280D] text-[#101828] bg-white' : 'text-[#98A2B3]']" @click="changePreviewDevice(device.name)" />
                    </div>
                </div>
                <!-- content -->
                <div class="p-[30px] mt-12 shadow-[0px_75px_150px_0px_#34405424] m-auto" @click.prevent="console.log('prevent click')" :style="`width: ${previewWidth}`">
                    <div class="w-[132px] h-[32px] m-6">
                        <img class="h-full" :src="$settings.business.logo_url||$settings.business.full_logo_url" />
                    </div>
                    <!-- <div class="p-8"> -->
                    <div class="p-8 ql-editor" v-html="activeTab == 'customer' ? email.customer_body : email.staff_body"></div>
                    <!-- <Button type="primary" radius="square" size="lg" classButton="w-[175px]" class="mt-8">Download invoice</Button> -->
                    <!-- </div> -->
                    <div class="p-8">
                        <p class="mb-12 text-sm font-normal" v-html="email_footer"></p>
                        <div class="flex items-center justify-between">
                            <div class="w-[132px] h-[32px]">
                                <img class="h-full" :src="$settings.business.logo_url" />
                            </div>
                            <!-- <div class="flex gap-4">
                                <a :href="social.url" v-for=" social in socialMedia " :key="social.name"
                                    target="_blank">
                                    <Icon :name="social.icon" size="20px" class="text-[#98A2B3]" />
                                </a>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style></style>